module.exports = __webpack_public_path__ + "img/LOGO.597eac97.jpg";